export default __webpack_public_path__ + "static/media/icon_alert.59dbc371.svg";